import {
  RIGHT_BOUNDARY_INDEXES,
  LEFT_BOUNDARY_INDEXES,
  OUT_BOUNDARY_INDEXES,
} from '@/entities/EPeriodontalMapTable/constants/periodontal.const'
import { DirectionType } from '@/entities/EPeriodontalMapTable/types/periodontalMap.type'

let nextDirection: DirectionType

export const removeSelectionRanges = (): void => {
  if (window.getSelection) {
    window.getSelection().removeAllRanges()
  }
}

export const getTabDirection = (
  currentInputId: string,
  inputs: HTMLInputElement[]
): DirectionType => {
  const currentInputIndex = inputs.findIndex(
    (input) => input.id === currentInputId
  )

  if (
    OUT_BOUNDARY_INDEXES[0] < currentInputIndex &&
    currentInputIndex < RIGHT_BOUNDARY_INDEXES[0]
  )
    return 'right'

  if (
    LEFT_BOUNDARY_INDEXES[1] < currentInputIndex &&
    currentInputIndex < RIGHT_BOUNDARY_INDEXES[2]
  )
    return 'right'

  return 'left'
}

export const getNextInputIndexByArrow = (
  inputs: HTMLInputElement[],
  currentInputId: string,
  direction: DirectionType
): number => {
  nextDirection = direction
  let nextIndex = getNextInputIndex(inputs, currentInputId, direction)

  while (isInputOnRemovedTooth(inputs[nextIndex])) {
    const indexWithOffset = getIndexWithOffset(nextIndex, nextDirection)

    if (nextIndex === indexWithOffset) break

    nextIndex = indexWithOffset
  }

  return nextIndex
}

const isInputOnRemovedTooth = (input: HTMLInputElement): boolean => {
  return !!input.closest('.periodontal-map-table__column-content--hidden')
}

const getNextInputIndex = (
  inputs: HTMLInputElement[],
  currentInputId: string,
  direction: DirectionType
): number => {
  const currentInputIndex = inputs.findIndex(
    (input) => input.id === currentInputId
  )

  let nextInputIndex = currentInputIndex

  if (direction === 'right') nextInputIndex = currentInputIndex + 1
  if (direction === 'left') nextInputIndex = currentInputIndex - 1

  if (isBoundaryInputIndex(nextInputIndex, direction))
    return getInputIndexOnNextLine(nextInputIndex, direction)

  return nextInputIndex
}

const getIndexWithOffset = (
  index: number,
  direction: DirectionType
): number => {
  if (isBoundaryInputIndex(index + 3, 'right')) {
    nextDirection = 'left'
    return getInputIndexOnNextLine(index + 3, 'right')
  }

  if (isBoundaryInputIndex(index - 3, 'left')) {
    nextDirection = 'right'
    return getInputIndexOnNextLine(index - 3, 'left')
  }

  if (direction === 'right') return index + 3
  if (direction === 'left') return index - 3

  return index
}

const isBoundaryInputIndex = (
  index: number,
  direction: DirectionType
): boolean => {
  return (
    (direction === 'right' && RIGHT_BOUNDARY_INDEXES.includes(index)) ||
    (direction === 'left' && LEFT_BOUNDARY_INDEXES.includes(index)) ||
    OUT_BOUNDARY_INDEXES.includes(index)
  )
}

const getInputIndexOnNextLine = (
  index: number,
  direction: DirectionType
): number => {
  if (direction === 'right') {
    const ind = RIGHT_BOUNDARY_INDEXES.findIndex((item) => item === index)

    if (ind === 0) return LEFT_BOUNDARY_INDEXES[1]
    if (ind === 1) return LEFT_BOUNDARY_INDEXES[0]
    if (ind === 2) return OUT_BOUNDARY_INDEXES[1] - 1

    return RIGHT_BOUNDARY_INDEXES[2] - 1
  }

  const ind = LEFT_BOUNDARY_INDEXES.findIndex((item) => item === index)

  if (ind === 0) return RIGHT_BOUNDARY_INDEXES[1]
  if (ind === 1) return RIGHT_BOUNDARY_INDEXES[0]
  if (ind === 2) return RIGHT_BOUNDARY_INDEXES[2]

  return 0
}
